module.exports = __webpack_public_path__ + "static/jellygon_logo_cursive_small-bf5d482e5a03ba97e3cf79c97eb531ce.png";